import {
    InternalStandardProps,
    OutlinedTextFieldProps,
    TextField,
} from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledTextField = styled(TextField)(({ theme }) => ({
    "& label.Mui-focused": {
        color: `${theme.colors.textField.focus}`,
    },
    "& .MuiInput-underline:after": {
        borderBottomColor: `${theme.colors.textField.focus}`,
    },
    "& .MuiOutlinedInput-root": {
        color: `${theme.palette.common.black} !important`,
        "& fieldset": {
            borderColor: `${theme.palette.grey[600]}`,
        },
        "&:hover fieldset": {
            borderColor: `${theme.colors.textField.focus}`,
        },
        "&.Mui-focused fieldset": {
            borderColor: `${theme.colors.textField.focus} !important`,
        },
    },

    "& input:-webkit-autofill, & input:-webkit-autofill:hover, & input:-webkit-autofill:focus":
        {
            transition:
                "background-color 5000s ease-in-out 0s, color 5000s ease-in-out 0s",
            transitionDelay: "background-color 5000s, color 5000s",
        },
}));

export interface AppOutlinedTextFieldPropsProps
    extends InternalStandardProps<OutlinedTextFieldProps> {}

export const AppOutlineTextFeild = (props: AppOutlinedTextFieldPropsProps) => {
    const { className, ...rest } = props;

    return (
        <StyledTextField
            className={className}
            style={{
                paddingBottom: "20px",
            }}
            {...rest}
        />
    );
};
